export default __webpack_public_path__ + "static/media/confused.2de4b436.svg";